
























import { Component, Vue } from "vue-property-decorator";
import KepatuhanVisiteDpjpList from "@/components/kepatuhan-visite-dpjp/KepatuhanVisiteDpjpList.vue";
import ScorecardDpjpTab from "@/pages/ScorecardDpjpPage.vue";

@Component({
  components: { KepatuhanVisiteDpjpList, ScorecardDpjpTab }
})
export default class KepatuhanVisiteDpjpPage extends Vue {
  activeTab = 0;

  mounted() {
    // Support direct navigation to scorecard tab via query
    if (this.$route.query.tab === "scorecard") {
      this.activeTab = 1;
    }
  }
}
